<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.84668 1C9.3256 1.0001 9.78403 1.19609 10.1143 1.54297L10.668 2.12598L12.5176 4.06836C12.8215 4.3877 12.9928 4.80977 12.999 5.25L13 13.25C13 14.2165 12.2165 15 11.25 15H4.75C3.7835 15 3 14.2165 3 13.25V2.75C3 1.7835 3.7835 1 4.75 1H8.84668ZM4.75 2.5C4.61193 2.5 4.5 2.61193 4.5 2.75V13.25C4.5 13.3881 4.61193 13.5 4.75 13.5H11.25C11.3881 13.5 11.5 13.3881 11.5 13.25V6.75H8.2002C7.67553 6.75 7.25 6.32447 7.25 5.7998V2.5H4.75ZM8.75 5.25H11.4971C11.4915 5.19498 11.4691 5.14293 11.4307 5.10254L9.02734 2.57715C8.98026 2.52784 8.91486 2.5001 8.84668 2.5H8.75V5.25Z"
    fill="currentColor"
  />
</template>
